import React from "react";

export const menuMargauxMotinConfig = {
  background: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="538"
      height="290"
      viewBox="0 0 538 290"
      fill="none"
      className="menu-margaux-motin-background"
    >
      <path
        d="M150.287 2.97233C102.727 6.82792 46.1847 12.4777 19.79 51.0591C-2.27741 83.3163 -7.58924 125.27 12.5709 159.143C23.1944 176.983 40.7294 192.66 57.0748 206.835C74.2611 221.749 93.2727 235.084 114.93 245.048C160.48 265.993 213.823 279.201 264.869 285.869C313.577 292.231 364.911 291.01 413.414 283.82C452.565 278.018 491.552 266.133 515.342 237.362C528.447 221.52 534.887 202.471 536.179 183.269C539.358 136.213 542.844 83.0364 504.657 44.1114C470.551 9.34744 407.794 7.12061 358.942 4.28299C297.519 0.707331 235.07 -1.6722 173.564 1.44536C165.791 1.83983 158.019 2.33609 150.266 2.97233"
        fill="white"
      />
    </svg>
  ),
};
